import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { xmlns: "http://www.w3.org/2000/svg" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("pattern", {
    id: "a",
    width: "20",
    height: "20",
    patternTransform: "scale(4)",
    patternUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "100%",
      height: "100%",
      fill: "transparent"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-width": ".5",
      d: "M-10-10A10 10 0 0 0-20 0a10 10 0 0 0 10 10A10 10 0 0 1 0 0a10 10 0 0 0-10-10zm20 0A10 10 0 0 0 0 0a10 10 0 0 1 10 10A10 10 0 0 1 20 0a10 10 0 0 0-10-10zm20 0A10 10 0 0 0 20 0a10 10 0 0 1 10 10A10 10 0 0 1 40 0a10 10 0 0 0-10-10zm-40 20a10 10 0 0 0-10 10 10 10 0 0 0 10 10A10 10 0 0 1 0 20a10 10 0 0 0-10-10zm20 0A10 10 0 0 0 0 20a10 10 0 0 1 10 10 10 10 0 0 1 10-10 10 10 0 0 0-10-10zm20 0a10 10 0 0 0-10 10 10 10 0 0 1 10 10 10 10 0 0 1 10-10 10 10 0 0 0-10-10z"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "800%",
  height: "800%",
  fill: "url(#a)"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }